// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Mybe","title":"styles_title__2OWBI"};